import { render, staticRenderFns } from "./CaptureComponent.vue?vue&type=template&id=d94a5428&scoped=true&"
import script from "./CaptureComponent.vue?vue&type=script&lang=js&"
export * from "./CaptureComponent.vue?vue&type=script&lang=js&"
import style0 from "./CaptureComponent.vue?vue&type=style&index=0&id=d94a5428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94a5428",
  null
  
)

export default component.exports